import type { GetMeUserResponse } from "@nlc/shared-types";
import type { QueryClient } from "@tanstack/react-query";

import { USER_ROLES } from "@nlc/shared-types";
import { redirect } from "@tanstack/react-router";

export function requireSuperAdmin(context: { queryClient: QueryClient }): void {
  const userData = context.queryClient.getQueryData<GetMeUserResponse>([
    "user",
  ]);

  if (userData?.user?.roleName !== USER_ROLES.SUPER_ADMIN) {
    throw redirect({ to: "/requests" as string });
  }
}
